import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageUtils {
  public safeGetItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      throw new Error(`Erro ao obter dados no local storage: ${error}`);
    }
  }

  public safeSetItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      throw new Error(`Erro ao salvar dados no local storage: ${error}`);
    }
  }

  public safeRemoveItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      throw new Error(`Erro ao excluir dados no local storage: ${error}`);
    }
  }
}
